module.exports = __webpack_public_path__ + "static/img/23a.eed4bbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23a.jpg
// module id = HLAw
// module chunks = 0